import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { hotelPath } from 'app/hooks/data/hotels/useHotel';
import type {
  ExtranetHotelFinance,
  ExtranetHotelFinanceForm,
} from 'app/typings/core/extranet/hotel/finance';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useSaveHotelFinance(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ExtranetHotelFinanceForm) =>
      apiMutation(
        'PUT',
        {
          path: ENDPOINTS.saveHotelFinance,
          params: { id: hotelId.toString() },
        },
        payload
      ) as Promise<ExtranetHotelFinance>,
    onSuccess: (finance) => {
      message.success('Billing information saved');

      queryClient.setQueryData(
        [CORE_QUERY_KEYS.hotelFinance, hotelId],
        finance
      );
      queryClient.invalidateQueries({ queryKey: [hotelPath, { hotelId }] });
    },
    onError: () => {
      message.error('Error while saving billing information');
    },
  });
}
